/* eslint-disable import/no-cycle */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable max-lines */
import moment from 'moment';
import { useContext } from 'react';
import { Box, Typography } from '@mui/material';

import AES from 'crypto-js/aes';
import CryptoJS from 'crypto-js';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import './OtpLogin/ReceiveCode.css';
import CheckBoxTick from '../images/checkBox-tick.svg';
import {
  MANDATORY_FIELD_ERR,
  HOMEUS_PR,
  HOME_PR,
  HOME_VI,
  HOME_USA,
  HOMEUS_VI,
  SELF_EMPLOYED,
  EMPLOYED,
  INVALID_FORMAT_ERR,
  INVALID_DATE,
  PROGRESA_CONTIGO,
  ELITE_ACCOUNT_EN,
  PRODUCT_PERSONAL,
  SALES,
  LIBRE_AHORRA_BUNDLE,
  INVALID_FORMAT_ERR_BUNDLE,
  DOB_DAY,
  CD_IRA,
  PRODUCT_IRAEDUCATION,
} from '../constants';

import { businessMapping } from '../services/businessMapping';
import { fetchVouchedAddress, getAddressLookupData } from '../services/formService';
import { productMapping } from '../services/productMapping';
import { saveKnockOffData } from './DGI/CommonFunctions';
import { addAutoCompleteCityToDropdownIfMissing } from './DGI/DGIAccountInfoUtils';
import { dgiMapping } from '../services/dgiMapping';
import { productNameURLMapping } from '../services/productNameURLMapping';
import { dgiContMapping } from '../services/dgiContMapping';
import CommonDataContext from '../WebComponents/context/CommonDataContext';
import LeadGenerationContext from '../context/LeadGenerationContext';
import { handleApiEnviroment } from '../WebComponents/commonComponents/customUtils';

export const commonTernary = (condition, result1, result2) => {
  if (condition) {
    return result1;
  }
  return result2;
};
export const isWebComponentFlow = () => {
  const commonDataContext = useContext(CommonDataContext);
  const leadGenerationContext = useContext(LeadGenerationContext);

  return commonDataContext?.wcFlow && commonDataContext !== undefined
    ? commonDataContext
    : leadGenerationContext;
};

export const commonFunction = (value) => {
  if (value) {
    return value;
  }
  return null;
};
export const zipCodeValueSetError = (zipcode) => {
  if (zipcode?.match(/^0*$/g)) {
    return '* Please enter a valid zipcode';
  }
  return '';
};
export const employedCommon = (e, leadGenerationContext, invalidMssg) => {
  if (e.target.value.length >= 2 && e.target.value.match(/^[A-Za-z0-9@&_.\-\s,()]*$/)) {
    leadGenerationContext.setEmploymentInformationErrors({
      ...leadGenerationContext.employmentInformationErrors,
      [e.target.name]: '',
    });
  } else if (e.target.value.length === 0) {
    leadGenerationContext.setEmploymentInformationErrors({
      ...leadGenerationContext.employmentInformationErrors,
      [e.target.name]: '* Mandatory Field',
    });
  } else {
    leadGenerationContext.setEmploymentInformationErrors({
      ...leadGenerationContext.employmentInformationErrors,
      [e.target.name]: invalidMssg,
    });
  }
};

export const handleETBFlow = (leadGenerationContext, history, nextPage) => {
  if (
    leadGenerationContext.customerType === 'ETB' &&
    leadGenerationContext.flowTypeETB === 'EtbFlow'
  ) {
    if (leadGenerationContext?.wcFlow) {
      history.push(nextPage);
    } else {
      history.push(
        `/${leadGenerationContext.location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/express/retail-form/${productNameURLMapping(
          leadGenerationContext.productName
        )}/${nextPage}`
      );
    }
  }
};
export const isEtbFlow = (leadGenerationContext) =>
  (leadGenerationContext.customerType === 'ETB' &&
    leadGenerationContext.flowTypeETB === 'EtbFlow') ||
  false;

function areAllNumbersSameInPhoneNumber(phoneWithHyphens, leadGenerationContext) {
  let newPhoneNumber;
  const phoneWithoutHyphens = phoneWithHyphens?.replace(/[-() ]/g, '');
  if (phoneWithoutHyphens.length === 7 && leadGenerationContext.location !== 'VI') {
    newPhoneNumber = phoneWithoutHyphens;
  } else if (phoneWithoutHyphens.length === 10 && leadGenerationContext.location === 'VI') {
    newPhoneNumber = phoneWithoutHyphens.substring(3);
  }
  if (newPhoneNumber && newPhoneNumber.length === 7) {
    const numbersArray = Array.from(newPhoneNumber);
    const firstNumber = numbersArray[0];
    return numbersArray.every((number) => number === firstNumber);
  }
  return false;
}

export const checkInvalidMobileNumber = (phoneNumber, leadGenerationContext) => {
  const result = areAllNumbersSameInPhoneNumber(phoneNumber, leadGenerationContext);
  return result;
};

export const autoCompleteOccupation = (name, value, leadGenerationContext) => {
  leadGenerationContext.setIsScreenFourDirty(true);
  leadGenerationContext.setIsScreenFiveDirty(true);
  leadGenerationContext.setIsFeatureScreenDirty(true);
  leadGenerationContext.setIsFundingScreenDirty(true);
  leadGenerationContext.setEmploymentInformation({
    ...leadGenerationContext.employmentInformation,
    [name]: value,
  });
  if (value === null) {
    leadGenerationContext.setEmploymentInformationErrors({
      ...leadGenerationContext.employmentInformationErrors,
      [name]: '* Mandatory Field',
    });
  } else {
    leadGenerationContext.setEmploymentInformationErrors({
      ...leadGenerationContext.employmentInformationErrors,
      [name]: '',
    });
  }
};

export const autoCompleteCommon = (name, value, leadGenerationContext) => {
  leadGenerationContext.setIsTrustInfoDirty(true);
  leadGenerationContext.setIsFinanceInfoDirty(true);
  leadGenerationContext.setIsFundingScreenDirty(true);
  leadGenerationContext.setIsEdeliveryScreenDirty(true);

  leadGenerationContext.setDgiEmploymentStatus({
    ...leadGenerationContext.dgiEmploymentStatus,
    [name]: value,
  });
  if (value === null) {
    leadGenerationContext.setDgiEmploymentStatusErrors({
      ...leadGenerationContext.dgiEmploymentStatusErrors,
      [name]: MANDATORY_FIELD_ERR,
    });
  } else {
    leadGenerationContext.setDgiEmploymentStatusErrors({
      ...leadGenerationContext.dgiEmploymentStatusErrors,
      [name]: '',
    });
  }
};
export const handleCurrency = (curr) => {
  const currencyValue = curr?.replace(/^0+/, '');
  const newCurrencyValue = nbrToCurrencyFormat(currencyValue);
  const newDeposit = `${'$'}${newCurrencyValue}${'.00'}`;
  return newDeposit;
};
export const autoCompleteCommonCommercial = (name, value, leadGenerationContext) => {
  leadGenerationContext.setIsBusinessAdditionalInfoDirty(true);
  leadGenerationContext.setIsBusinessSuriDirty(true);
  leadGenerationContext.setIsBusinessCompDirty(true);
  leadGenerationContext.setIsBusinessAccountInfoDirty(true);
  leadGenerationContext.setIsDocChecklistDirty(true);
  leadGenerationContext.setIsCommercialProductUIDirty(true);

  leadGenerationContext.setBusinessAdditionalInfo({
    ...leadGenerationContext.businessAdditionalInfo,
    [name]: value,
  });
  if (value === null) {
    leadGenerationContext.setBusinessAdditionalInfoErrors({
      ...leadGenerationContext.businessAdditionalInfoErrors,
      [name]: MANDATORY_FIELD_ERR,
    });
  } else {
    leadGenerationContext.setBusinessAdditionalInfoErrors({
      ...leadGenerationContext.businessAdditionalInfoErrors,
      [name]: '',
    });
  }
};
export const autoCompleteConCommon = (name, value, leadGenerationContext) => {
  leadGenerationContext.setConEmploymentStatus({
    ...leadGenerationContext.conEmploymentStatus,
    [name]: value,
  });
  if (value === null) {
    leadGenerationContext.setConEmploymentStatusError({
      ...leadGenerationContext.conEmploymentStatusError,
      [name]: MANDATORY_FIELD_ERR,
    });
  } else {
    leadGenerationContext.setConEmploymentStatusError({
      ...leadGenerationContext.conEmploymentStatusError,
      [name]: '',
    });
  }
};

export const empStatusAsEmpSelfEmp = (addressObject, leadGenerationContext) => {
  const { dgiEmploymentStatus } = leadGenerationContext;
  if (
    dgiEmploymentStatus.empStatus === SELF_EMPLOYED ||
    dgiEmploymentStatus.empStatus === EMPLOYED
  ) {
    leadGenerationContext.setIsTrustInfoDirty(true);
    leadGenerationContext.setIsFinanceInfoDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);
    leadGenerationContext.setIsEdeliveryScreenDirty(true);
  } else if (leadGenerationContext.isCheckedTrustContact === true) {
    leadGenerationContext.setIsTrustInfoDirty(true);
    leadGenerationContext.setIsFinanceInfoDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);
  }
};
const handleAddressInfo = (addressObject) => {
  let contryVal;
  if (addressObject?.Address?.CountrySubdivisionCode === HOMEUS_PR) {
    contryVal = HOME_PR;
  } else if (addressObject?.Address?.CountrySubdivisionCode === HOMEUS_VI) {
    contryVal = HOME_VI;
  } else {
    contryVal = HOME_USA;
  }
  return contryVal;
};
export const addressAutocomplete = (addressObject, leadGenerationContext) => {
  const { dgiEmploymentStatus, dgiEmploymentStatusErrors } = leadGenerationContext;

  empStatusAsEmpSelfEmp(addressObject, leadGenerationContext);

  let city = '';
  let state = '';
  let country = '';
  let zipCode = '';
  let address1 = '';
  if (
    addressObject?.Address?.AddressLine1 ||
    addressObject?.Address?.PostalCode ||
    addressObject?.Address?.City
  ) {
    address1 = commonFunction(addressObject?.Address?.AddressLine1);
    zipCode = addressObject?.Address?.PostalCode.split('-')[0];
    city = addressObject?.Address?.City;
  }
  country = handleAddressInfo(addressObject);

  if (
    (addressObject?.Address?.State && country === HOME_VI) ||
    (addressObject?.Address?.State && country === HOME_PR)
  ) {
    state = 'N/A';
  } else {
    state = addressObject?.Address?.State;
  }

  const cityPresent = addAutoCompleteCityToDropdownIfMissing(country, state, city);

  if (
    dgiEmploymentStatus.empStatus === SELF_EMPLOYED ||
    dgiEmploymentStatus.empStatus === EMPLOYED
  ) {
    if (!cityPresent) {
      leadGenerationContext.setDgiEmploymentStatus({
        ...dgiEmploymentStatus,
        missingAutoCompleteCity: city,
      });
    }
    leadGenerationContext.setDgiEmploymentStatus({
      ...dgiEmploymentStatus,
      address1,
      city,
      country,
      state,
      zipCode,
    });
    leadGenerationContext.setDgiEmploymentStatusErrors({
      ...dgiEmploymentStatusErrors,
      address1: '',
      city: '',
      country: '',
      state: '',
      zipCode: zipCodeValueSetError(zipCode),
    });
  }
};
export const addressAutocompleteTrusted = (addressObject, leadGenerationContext) => {
  let city = '';
  let state = '';
  let country = '';
  let zipCode = '';
  let address1 = '';
  if (
    addressObject?.Address?.AddressLine1 ||
    addressObject?.Address?.PostalCode ||
    addressObject?.Address?.City
  ) {
    address1 = commonFunction(addressObject?.Address?.AddressLine1);
    zipCode = addressObject?.Address?.PostalCode.split('-')[0];
    city = addressObject?.Address?.City;
  }
  country = handleAddressInfo(addressObject);

  if (
    (addressObject?.Address?.State && country === HOME_VI) ||
    (addressObject?.Address?.State && country === HOME_PR)
  ) {
    state = 'N/A';
  } else {
    state = addressObject?.Address?.State;
  }

  const cityPresent = addAutoCompleteCityToDropdownIfMissing(country, state, city);

  if (leadGenerationContext.isCheckedTrustContact === true) {
    if (!cityPresent) {
      leadGenerationContext.setTrustedContactInformation((prevState) => ({
        ...prevState,
        missingAutoCompleteCity: city,
      }));
    }

    leadGenerationContext.setTrustedContactInformation((prevState) => ({
      ...prevState,
      address1,
      city,
      country,
      state,
      zipCode,
    }));
    leadGenerationContext.setTrustedContactInformationErrors((prevState) => ({
      ...prevState,
      address1: '',
      city: '',
      country: '',
      state: '',
      zipCode: zipCodeValueSetError(zipCode),
    }));
  }
};

export async function fetchAddressLookup(
  address1,
  country,
  query,
  accessToken,
  setAddressLookupData,
  setAddressLookupDataResponse,
  setCallLookupApi,
  setCallLookupApiHome,
  setCallLookupApiEmp,
  setCallLookupApiHomeSelfEmp,
  baseContext
) {
  if (address1?.length >= 6) {
    const response = await getAddressLookupData(
      country,
      query,
      accessToken,
      setCallLookupApi,
      setCallLookupApiHome,
      setCallLookupApiEmp,
      setCallLookupApiHomeSelfEmp,
      { isWCFlow: baseContext?.wcFlow, env: handleApiEnviroment(baseContext?.environment) }
    );
    if (response?.data?.Results) {
      const options = [];
      response.data.Results.forEach((result) => {
        const address = result.Address;
        const zipCode = address.PostalCode.split('-')[0];
        options.push(`${address.AddressLine1}, ${address.City}, ${address.State}, ${zipCode}`);
      });
      setAddressLookupData(options);
    }
    setAddressLookupDataResponse(response);
  }
}
export const commonBusinessContactChange = (e, leadGenerationContext, reg) => {
  const {
    setBusinessContactInformation,
    setBusinessContactInformationErrors,
    setSaveAppContactInfo,
    setSaveAppContactInfoErrors,
  } = leadGenerationContext;
  if (e.target.value.match(reg)) {
    setBusinessContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    setBusinessContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    if (e.target.name === 'lastName') {
      setSaveAppContactInfo((prevState) => ({
        ...prevState,
        lastName: e.target.value,
      }));
      setSaveAppContactInfoErrors((prevState) => ({ ...prevState, lastName: '' }));
    }
  } else if (e.target.value === '') {
    setBusinessContactInformation((prevState) => ({ ...prevState, [e.target.name]: '' }));
    setBusinessContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '* Mandatory Field',
    }));
  } else {
    setBusinessContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    setBusinessContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '* Invalid Format',
    }));
  }
};

export const contactNameChange = (e, leadGenerationContext, regex) => {
  const { setContactInformation, setContactInformationErrors, productName } = leadGenerationContext;
  if (e.target.value.match(regex)) {
    setContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    setContactInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
  } else if (e.target.value === '') {
    setContactInformation((prevState) => ({ ...prevState, [e.target.name]: '' }));
    setContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));
  } else {
    setContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    setContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]:
        productMapping(productName) === LIBRE_AHORRA_BUNDLE
          ? INVALID_FORMAT_ERR_BUNDLE
          : INVALID_FORMAT_ERR,
    }));
  }
};
export const saveAppcontactNameChange = (e, leadGenerationContext, regex) => {
  const {
    setSaveAppContactInfo,
    setSaveAppContactInfoErrors,
    setPersonalInformation,
    setPersonalInformationErrors,
    setContactInformation,
    setContactInformationErrors,
    setBusinessContactInformation,
    setBusinessContactInformationErrors,
    productName,
  } = leadGenerationContext;
  if (e.target.value.match(regex)) {
    setSaveAppContactInfo((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    setSaveAppContactInfoErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));

    setBusinessContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    setBusinessContactInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));

    setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    setContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    setContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
  } else if (e.target.value === '') {
    setSaveAppContactInfo((prevState) => ({ ...prevState, [e.target.name]: '' }));
    setSaveAppContactInfoErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));

    setBusinessContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    setBusinessContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));

    setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));

    setContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    setContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));
  } else {
    setSaveAppContactInfo((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    setSaveAppContactInfoErrors((prevState) => ({
      ...prevState,

      [e.target.name]:
        productMapping(productName) === LIBRE_AHORRA_BUNDLE
          ? INVALID_FORMAT_ERR_BUNDLE
          : INVALID_FORMAT_ERR,
    }));
  }
};
const timeOutFunc = (selectionStart, numkeys, e) => {
  setTimeout(() => {
    const input = getRoot().getElementById('dgiAccountNumber');
    if (input?.setSelectionRange) {
      if (selectionStart + 1 === 4 && e.target.value.charAt(selectionStart - 1).includes(numkeys)) {
        input.setSelectionRange(selectionStart + 2, selectionStart + 2);
      } else if (selectionStart !== 4) {
        input.setSelectionRange(selectionStart, selectionStart);
      } else if (selectionStart === 4) {
        e.target.selectionEnd = selectionStart + 1;
      }
    }
  }, 10);
};
export const changeDgiAccNumberAndroid = (e, leadGenerationContext) => {
  const { setIsFundingScreenDirty, setFundData, setFundDataErrors, fundDataErrors, fundData } =
    leadGenerationContext;
  setIsFundingScreenDirty(true);
  const { selectionStart } = e.target;
  const alpha1 = Array.from(Array(26)).map((_e, i) => i + 65);
  const alphabet = alpha1.map((x) => String.fromCharCode(x));
  const smallAlpha = Array.from(Array(26)).map((_e, i) => i + 97);
  const smallAlphabet = smallAlpha.map((x) => String.fromCharCode(x));
  const nums = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const numkeys = [...nums, ...alphabet, ...smallAlphabet];

  let ssnValue = e.target.value;
  ssnValue = ssnValue.replace(/[^a-zA-Z0-9]/g, '');
  ssnValue = ssnValue.replace('-', '');
  if (e.target.value.length <= 10) {
    if (ssnValue?.toString().length >= 4) {
      ssnValue = `${ssnValue.slice(0, 3)}-${ssnValue.slice(3, ssnValue.toString().length)}`;
    }
    const alpha = ssnValue.slice(0, 3);
    if (alpha.match(/[N|n][E|e][E|c|e|C]/)) {
      setFundDataErrors({
        ...fundDataErrors,
        [e.target.name]: '',
      });
    } else {
      setFundDataErrors({
        ...fundDataErrors,
        [e.target.name]: '* Please enter a valid DGI account number',
      });
    }
    const num = ssnValue.slice(4, ssnValue.toString().length);
    if (!(num.match(/^\d+$/) && num.length === 6)) {
      setFundDataErrors({
        ...fundDataErrors,
        [e.target.name]: '* Please enter a valid DGI account number',
      });
    }
    timeOutFunc(selectionStart, numkeys, e);

    if (ssnValue === '') {
      setFundDataErrors({
        ...fundDataErrors,
        [e.target.name]: '* Mandatory Field',
      });
    }
    setFundData({ ...fundData, [e.target.name]: ssnValue });
  }
};

export const addressLineCheck = (address) => {
  let addrVal;
  if (address) {
    if (address.length <= 30) {
      addrVal = address;
    } else {
      addrVal = address.slice(0, 30);
    }
  } else {
    addrVal = '';
  }
  return addrVal;
};
export const clearOCRdata = (leadGenerationContext) => {
  const {
    setAddressProofUploadStatus,
    setAddressInformation,
    setAddressInformationErrors,
    addressInformation,
  } = leadGenerationContext;
  setAddressProofUploadStatus(null);
  setAddressInformation((prevState) => ({
    ...prevState,
    address1: '',
    address2: '',
    state: '',
    country: '',
    city: '',
    zipCode: '',
    vouchedAddrEdited: true,
  }));
  setAddressInformationErrors((prevState) => ({
    ...prevState,
    address2: '',
  }));
  if (addressInformation?.sameMailingAddress) {
    setAddressInformation((prevState) => ({
      ...prevState,
      permanentAddress1: '',
      permanentAddress2: '',
      permanentState: '',
      permanentCountry: '',
      permanentCity: '',
      permanentZipCode: '',
    }));
  }
};
export const handleAddressEditModal = (leadGenerationContext) => {
  const { setAddressEditQuestionModal, popupModalIntial } = leadGenerationContext;

  if (popupModalIntial) {
    setAddressEditQuestionModal(true);
  } else setAddressEditQuestionModal(false);
};

export const emailChange = (e, leadGenerationContext) => {
  const {
    setSaveAppContactInfo,
    setSaveAppContactInfoErrors,
    setPersonalInformation,
    setPersonalInformationErrors,
    setBusinessContactInformation,
    setBusinessContactInformationErrors,
    productName,
  } = leadGenerationContext;
  if (
    e.target.value.match(
      /^([a-zA-Z0-9_.-]+)@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/
    )
  ) {
    const emailFirstPart = e.target.value.split('@');
    if (
      emailFirstPart[0].charAt(0) !== '.' &&
      emailFirstPart[0].charAt(0) !== '-' &&
      emailFirstPart[0].charAt(emailFirstPart[0].length - 1) !== '-' &&
      emailFirstPart[0].charAt(emailFirstPart[0].length - 1) !== '.' &&
      !e.target.value.match(/[.\-_]{2,}/)
    ) {
      setPersonalInformation((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setSaveAppContactInfo((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setSaveAppContactInfoErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setBusinessContactInformation((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setBusinessContactInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setPersonalInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
    } else {
      setPersonalInformation((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setPersonalInformationErrors((prevState) => ({
        ...prevState,

        [e.target.name]:
          productMapping(productName) === LIBRE_AHORRA_BUNDLE
            ? INVALID_FORMAT_ERR_BUNDLE
            : INVALID_FORMAT_ERR,
      }));
      setSaveAppContactInfo((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setSaveAppContactInfoErrors((prevState) => ({
        ...prevState,

        [e.target.name]:
          productMapping(productName) === LIBRE_AHORRA_BUNDLE
            ? INVALID_FORMAT_ERR_BUNDLE
            : INVALID_FORMAT_ERR,
      }));
    }
  } else if (e.target.value === '') {
    setPersonalInformation((prevState) => ({ ...prevState, [e.target.name]: '' }));
    setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));
    setSaveAppContactInfo((prevState) => ({ ...prevState, [e.target.name]: '' }));
    setSaveAppContactInfoErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));
  } else {
    setPersonalInformation((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    setPersonalInformationErrors((prevState) => ({
      ...prevState,

      [e.target.name]:
        productMapping(productName) === LIBRE_AHORRA_BUNDLE
          ? INVALID_FORMAT_ERR_BUNDLE
          : INVALID_FORMAT_ERR,
    }));
    setSaveAppContactInfo((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    setSaveAppContactInfoErrors((prevState) => ({
      ...prevState,

      [e.target.name]:
        productMapping(productName) === LIBRE_AHORRA_BUNDLE
          ? INVALID_FORMAT_ERR_BUNDLE
          : INVALID_FORMAT_ERR,
    }));
  }
};
let dummyData = [];
const personalInfoDobChange = (personalInformation, saveAppContactInfo) => {
  if (personalInformation?.dob !== '') {
    if (personalInformation?.dob !== saveAppContactInfo?.dob) {
      if (!dummyData.includes('date of birth')) {
        dummyData.push('date of birth');
      }
    } else if (dummyData.includes('date of birth')) {
      const index = dummyData.indexOf('date of birth');
      dummyData.splice(index, 1);
    }
  }
};
export const handleCheckValuesSaveConti = (leadGenCont) => {
  const { personalInformation, saveAppContactInfo, vouchLastName } = leadGenCont;
  dummyData = [...leadGenCont.saveLaterVal];
  personalInfoDobChange(personalInformation, saveAppContactInfo);
  if (vouchLastName !== '') {
    if (vouchLastName !== saveAppContactInfo?.lastName) {
      if (!dummyData.includes('last name')) {
        dummyData.push('last name');
      }
    } else if (dummyData.includes('last name')) {
      const index = dummyData.indexOf('last name');
      dummyData.splice(index, 1);
    }
  }
  if (personalInformation?.ssn !== '') {
    if (personalInformation?.ssn !== saveAppContactInfo?.ssn) {
      if (!dummyData.includes('ssn')) {
        dummyData.push('ssn');
      }
    } else if (dummyData.includes('ssn')) {
      const index = dummyData.indexOf('ssn');
      dummyData.splice(index, 1);
    }
  }

  return dummyData;
};

/**
 * Handle Save Application button: Should be navigated to Save Application Page */
export const handleSaveApplication = (e, leadGenerationContext) => {
  const { setIsModalSaveLater } = leadGenerationContext;
  e.preventDefault();
  setIsModalSaveLater(true);
};
export const clearUploadFocus = () => {
  let element = '';
  element = getRoot().getElementById('uploadContainer');
  if (element) {
    if (isBundle) {
      element?.setAttribute(
        'style',
        'background-image: repeating-linear-gradient(0deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#808285,#808285 7px,transparent 8px,transparent 15px) !important; background-size: 1px 100%, 100% 1px, 1px 100%, 100% 1px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%'
      );
    } else {
      element?.setAttribute(
        'style',
        'background-image: repeating-linear-gradient(0deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#808285,#808285 7px,transparent 8px,transparent 15px) !important; background:#F4F4F4;background-size: 1px 100%, 100% 1px, 1px 100%, 100% 1px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%'
      );
    }
  }
};
export const getLang = (language, toLowerCase = false) => {
  let lang = 'En';
  if (language === 'ES') {
    lang = 'Es';
  }

  if (toLowerCase) return lang.toLowerCase();

  return lang;
};
export const nameProduct = (data) => {
  let setProduct;
  if (dgiMapping(data.productName)) {
    setProduct = dgiMapping(data.productName);
  } else if (dgiContMapping(data.productName)) {
    setProduct = dgiContMapping(data.productName);
  } else {
    setProduct = productMapping(data.productName);
  }
  return setProduct;
};
export const handleDOBchange = (newValue, leadGenerationContext) => {
  const {
    setPersonalInformation,
    personalInformation,
    setPersonalInformationErrors,
    personalInformationErrors,
    setBusinessAccountInfo,
    setBusinessAccountInfoError,
    businessAccountInfo,
    businessAccountInfoError,
    productName,
    setIsScreenTwoDirty,
  } = leadGenerationContext;

  if (isBundle(productName)) {
    setIsScreenTwoDirty(true);
  }

  if (businessMapping(productName)) {
    leadGenerationContext.setIsBusinessAccountInfoDirty(true);
    leadGenerationContext.setIsDocChecklistDirty(true);
    leadGenerationContext.setIsCommercialProductUIDirty(true);
    if (newValue) {
      const selectedDate = new Date(newValue);
      const currentdate = new Date();
      const formattedDate = moment(newValue).format('yyyy-MM-DD');

      setBusinessAccountInfo({ ...businessAccountInfo, dob: formattedDate });
      if (newValue == 'Invalid Date') {
        setBusinessAccountInfo({ ...businessAccountInfo, dob: formattedDate });
        setBusinessAccountInfoError({
          ...businessAccountInfoError,
          dob: INVALID_DATE,
        });
      } else if (selectedDate.getTime() > currentdate.getTime()) {
        setBusinessAccountInfoError({
          ...businessAccountInfoError,
          dob: INVALID_DATE,
        });
      } else {
        setBusinessAccountInfoError({ ...businessAccountInfoError, dob: '' });
      }
    } else {
      setBusinessAccountInfo({ ...businessAccountInfo, dob: '' });
      setBusinessAccountInfoError({
        ...businessAccountInfoError,
        dob: '* Mandatory Field',
      });
    }
  } else if (productMapping(productName) || dgiMapping(productName)) {
    if (newValue) {
      const selectedDate = new Date(newValue);
      const currentdate = new Date();
      const formattedDate = moment(newValue).format('yyyy-MM-DD');
      setPersonalInformation({ ...personalInformation, dob: formattedDate });
      if (newValue == 'Invalid Date') {
        setPersonalInformation({ ...personalInformation, dob: formattedDate });
        setPersonalInformationErrors({
          ...personalInformationErrors,
          dob: INVALID_DATE,
        });
      } else if (selectedDate.getTime() > currentdate.getTime()) {
        setPersonalInformationErrors({
          ...personalInformationErrors,
          dob: INVALID_DATE,
        });
      } else {
        setPersonalInformationErrors({ ...personalInformationErrors, dob: '' });
      }
    } else {
      setPersonalInformation({ ...personalInformation, dob: '' });
      setPersonalInformationErrors({
        ...personalInformationErrors,
        dob: MANDATORY_FIELD_ERR,
      });
    }
  }
};

export const getNameInUpperCase = (name) => {
  if (name?.includes(' ')) {
    const words = name.toLowerCase().split(' ');
    return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};
function cryptoRandom(len) {
  const uuid = uuidv4().replace(/-/g, '');
  return uuid.slice(0, len);
}
export const generateKey = () => cryptoRandom(32);

export const encryptData = (str, code) => {
  const prefix = cryptoRandom(16);
  const iv = CryptoJS.enc.Utf8.parse(code.substring(0, 16));
  const key = CryptoJS.enc.Utf8.parse(code);

  return AES.encrypt(prefix + str, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
};

export const decryptData = (str, code) => {
  const iv = CryptoJS.enc.Utf8.parse(code.substring(0, 16));
  const key = CryptoJS.enc.Utf8.parse(code);

  return AES.decrypt(str, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
    .toString(CryptoJS.enc.Utf8)
    .slice(16);
};
export const languageDone = (language) => {
  const { t } = useTranslation();
  if (language === 'EN') {
    return (
      <>
        {' '}
        <Typography variant="h2" className="welcomeTextR">
          {t('Welcome to ', {
            defaultValue: `Welcome to `,
          })}
          <span style={{ color: '#f5821f' }}>
            {t('O', {
              defaultValue: `O`,
            })}
          </span>
          {t('riental', {
            defaultValue: `riental`,
          })}
        </Typography>
      </>
    );
  }
  return (
    <Typography variant="h2" className="welcomeTextR">
      {t('Bienvenido a ', {
        defaultValue: `Bienvenido a `,
      })}
      <span style={{ color: '#f5821f' }}>
        {t('O', {
          defaultValue: `O`,
        })}
      </span>
      {t('riental', {
        defaultValue: `riental`,
      })}
    </Typography>
  );
};

export const handleDOBchangeSaveAppContact = (newValue, context) => {
  const {
    setSaveAppContactScreenDirty,
    setSaveAppContactInfo,
    saveAppContactInfo,
    setBusinessContactInformation,
    setPersonalInformation,
    personalInformation,
    setBusinessAccountInfo,
    businessAccountInfo,
    setSaveAppContactInfoErrors,
    saveAppContactInfoErrors,
    setBusinessAccountInfoError,
    businessAccountInfoError,
    setPersonalInformationErrors,
    personalInformationErrors,
    setBusinessContactInformationErrors,
  } = context;
  setSaveAppContactScreenDirty(true);
  if (newValue) {
    const selectedDate = new Date(newValue);
    const currentdate = new Date();
    const formattedDate = moment(newValue).format('yyyy-MM-DD');

    setSaveAppContactInfo({ ...saveAppContactInfo, dob: formattedDate });
    if (newValue != 'Invalid Date') {
      setBusinessContactInformation((prevState) => ({
        ...prevState,
        dob: formattedDate,
      }));
      setPersonalInformation({ ...personalInformation, dob: formattedDate });
      setBusinessAccountInfo({ ...businessAccountInfo, dob: formattedDate });
    }
    if (newValue == 'Invalid Date') {
      setSaveAppContactInfo({ ...saveAppContactInfo, dob: formattedDate });
      setSaveAppContactInfoErrors({
        ...saveAppContactInfoErrors,
        dob: INVALID_DATE,
      });
      setBusinessAccountInfo({ ...businessAccountInfo, dob: formattedDate });
      setBusinessAccountInfoError({
        ...businessAccountInfoError,
        dob: INVALID_DATE,
      });
    } else if (selectedDate.getTime() > currentdate.getTime()) {
      setSaveAppContactInfoErrors({
        ...saveAppContactInfoErrors,
        dob: INVALID_DATE,
      });
    } else {
      setSaveAppContactInfoErrors({ ...saveAppContactInfoErrors, dob: '' });
      setPersonalInformationErrors({ ...personalInformationErrors, dob: '' });
      setBusinessContactInformationErrors((prevState) => ({
        ...prevState,
        dob: '',
      }));
      setBusinessAccountInfoError({
        ...businessAccountInfoError,
        dob: '',
      });
    }
  } else {
    setSaveAppContactInfo({ ...saveAppContactInfo, dob: '' });
    setSaveAppContactInfoErrors({
      ...saveAppContactInfoErrors,
      dob: MANDATORY_FIELD_ERR,
    });
    setBusinessAccountInfoError({
      ...businessAccountInfoError,
      dob: MANDATORY_FIELD_ERR,
    });
  }
};
export const vouchedJobCallForFraudCheck = async (setIsValidating, leadGenerationContext) => {
  const {
    vouchedJob,
    accessToken,
    setVouchedResponseAddr,
    setPersonalInformation,
    setBusinessAccountInfo,
    setDisableContinue,
    setVouchedFailModal,
  } = leadGenerationContext;

  setIsValidating(true);
  const response = await fetchVouchedAddress(vouchedJob, accessToken);
  const vouchedResponse = response?.data?.items[0];
  setVouchedResponseAddr(vouchedResponse);
  if (vouchedResponse?.result?.success === false) {
    setIsValidating(false);
    setPersonalInformation((prevState) => ({ ...prevState, uploadSuccessStatus: null }));
    setBusinessAccountInfo((prevState) => ({
      ...prevState,
      uploadSuccessStatus: null,
    }));
    setDisableContinue(true);
    setVouchedFailModal(true);
    const ocrErrorList = [];
    let ocrErrorListinString = '';
    for (const x of vouchedResponse.errors) {
      ocrErrorList.push(x.message);
      ocrErrorListinString = ocrErrorList.join();
    }
    if (leadGenerationContext.productName !== PROGRESA_CONTIGO) {
      await saveKnockOffData(leadGenerationContext, ocrErrorListinString, vouchedJob, '');
    }
  } else {
    setIsValidating(false);
  }
};
export const isPlaidProduct = (prod) =>
  commonTernary(
    productMapping(prod) === ELITE_ACCOUNT_EN ||
      productMapping(prod) === 'Ahorra' ||
      productMapping(prod) === LIBRE_AHORRA_BUNDLE ||
      isIRAProduct(prod),
    true,
    false
  );
export const isCDproduct = (prod) =>
  commonTernary(
    productMapping(prod) === PRODUCT_PERSONAL,
    //  || productMapping(prod) === PRODUCT_PERSONALCD
    true,
    false
  );
export const formatDepositAmount = (amount, context) => {
  const { setCdFlowOffers, cdFlowOffers } = context;
  let finalAmount;
  if (amount.endsWith('.00')) {
    const valueWithoutDecimal = amount.slice(0, -3);
    finalAmount = valueWithoutDecimal.replace(/,/g, '');
    setCdFlowOffers({ ...cdFlowOffers, depositAmount: finalAmount });
  } else if (/^\d+$/.test(amount)) {
    finalAmount = amount;
  }
  return finalAmount;
};

export const isKnockOffValueEmployer = async (searchValue) => {
  const list = [
    'Creator Alliance',
    'Creator Alliance LLC',
    'Creator Alliance Puerto Rico',
    'Creators Alliance',
    'Creators Alliance LLC',
    'Creators Alliance Puerto Rico',
    'Creator Aliance',
    'Creator Aliance LLC',
    'Creator Aliance Puerto Rico',
  ];

  return list.some((x) => x.toLowerCase() === searchValue.toLowerCase());
};

export const nbrToCurrencyFormat = (nbr) => nbr?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
export const openNewAccountTab = () => {
  window.open(
    'https://cibng.ibanking-services.com/eAM/Credential/Index?orgId=878_221571415&FIFID=221571415&brand=878_221571415&appId=CeB&FIORG=878',
    '_blank'
  );
};
export const headersData = (customerType, flowTypeETB, customerAppId, accessToken, contentType) => {
  let headers;
  if (customerType === 'ETB' && flowTypeETB === 'EtbFlow') {
    headers = {
      appid: SALES,
      'Application-Id': customerAppId,
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': contentType,
    };
  } else {
    headers = {
      appid: SALES,
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': contentType,
    };
  }
  return headers;
};

// export const openSSPPortal = (otpToken, language) => {
//   localStorage.setItem('sessionData', otpToken);
//   const customAccessToken = otpToken || '';
//   const userType = otpToken ? 'ETB' : 'NTB';
//   console.log({ customAccessToken });
//   console.log({ userType });
// /  console.log(otpToken);

//   // const lang = commonTernary(language === 'EN', 'EN', 'ES');
//   const loginWindow = window.open(
//     `${process.env.REACT_APP_SSP_URL}/?language=${language}&flow=sso&userType=${userType}`,
//     '_blank'
//   );

//   setTimeout(() => {
//     if (loginWindow) {
//       loginWindow.postMessage({ sessionData: customAccessToken }, process.env.REACT_APP_SSP_URL);
//     }
//   }, 5000);
// };

export const isBundle = (product) =>
  commonTernary(productMapping(product) === LIBRE_AHORRA_BUNDLE, true, false);

export const checkMinAge = (result, leadGenerationContext) => {
  let isMinor = false;
  const handleAgeRuleValidation = (message) => {
    if (message && message.length > 0) {
      isMinor = true;
      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        dob: `* ${message}`,
      }));
      const element = getRoot().getElementById(DOB_DAY);
      if (element) {
        element.focus();
      }
    } else {
      isMinor = false;
      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        dob: '',
      }));
    }
  };
  if (result && result.data && result.data.MinAge) {
    if (result.data.MinAge[0]?.message) {
      handleAgeRuleValidation(result.data.MinAge[0].message);
    }
  }
  return isMinor;
};
export const isCDIraproduct = (product) =>
  commonTernary(productMapping(product) === CD_IRA, true, false);

export const formatSSN = (e, ssnObject) => {
  const { selectionStart } = e.target;
  let ssnValue = e.target.value;
  ssnValue = ssnValue?.replace(/\D/g, '');
  if (ssnValue?.toString().length >= 6) {
    ssnValue = `${ssnValue.slice(0, 5)}-${ssnValue.slice(5, ssnValue.toString().length)}`;
  }
  if (ssnValue?.toString().length >= 4) {
    ssnValue = `${ssnValue.slice(0, 3)}-${ssnValue.slice(3, ssnValue.toString().length)}`;
  }

  setTimeout(() => {
    const input = e.target;
    const isAdding = ssnValue.length >= (ssnObject?.ssn?.length || 0);
    if (input?.setSelectionRange) {
      if ((selectionStart === 4 || selectionStart === 7) && isAdding) {
        input.setSelectionRange(selectionStart + 1, selectionStart + 1);
      } else if ((selectionStart === 4 || selectionStart === 7) && !isAdding) {
        input.setSelectionRange(selectionStart - 1, selectionStart - 1);
      } else {
        input.setSelectionRange(selectionStart, selectionStart);
      }
    }
  }, 10);

  return ssnValue;
};

export const formatMaskedSSN = (
  e,
  ssnObject,
  INVALID,
  setErrorstate1,
  setErrorstate2,
  setErrorstate3
) => {
  let { value } = e.target;
  const inputChar = e.nativeEvent?.data;
  const isBackspace = e.nativeEvent?.inputType === 'deleteContentBackward';
  const isDelete = e.nativeEvent?.inputType === 'deleteContentForward';
  let actualSSN = ssnObject?.ssn?.replace(/-/g, '') || '';
  const newSSNArray = actualSSN.split('');

  const startPos = e.target?.selectionStart;
  const maskedBeforeCursor = value.slice(0, startPos);
  const cursorPosInRaw = maskedBeforeCursor.replace(/-/g, '').length;

  if (isBackspace || isDelete) {
    if (cursorPosInRaw >= 0) {
      newSSNArray.splice(cursorPosInRaw, 1);
    }
  } else if (inputChar && /^[0-9]$/.test(inputChar)) {
    newSSNArray.splice(cursorPosInRaw - 1, 0, inputChar);
  } else {
    if (typeof setErrorstate1 === 'function') {
      setErrorstate1((prevState) => ({ ...prevState, ssn: INVALID }));
    }
    if (typeof setErrorstate2 === 'function') {
      setErrorstate2((prevState) => ({ ...prevState, ssn: INVALID }));
    }
    if (typeof setErrorstate3 === 'function') {
      setErrorstate3((prevState) => ({ ...prevState, ssn: INVALID }));
    }
    return typeof value === 'string' ? value : '';
  }

  actualSSN = newSSNArray.join('');
  actualSSN = actualSSN?.replace(/\D/g, '');
  if (actualSSN?.toString().length >= 6) {
    actualSSN = `${actualSSN.slice(0, 5)}-${actualSSN.slice(5, actualSSN.toString().length)}`;
  }
  if (actualSSN?.toString().length >= 4) {
    actualSSN = `${actualSSN.slice(0, 3)}-${actualSSN.slice(3, actualSSN.toString().length)}`;
  }
  e.target.value = actualSSN;
  value = actualSSN;

  setTimeout(() => {
    const input = e.target;
    const isAdding = value.length >= (ssnObject?.ssn?.length || 0);
    if (input?.setSelectionRange) {
      if ((startPos === 4 || startPos === 7) && isAdding) {
        input.setSelectionRange(startPos + 1, startPos + 1);
      } else if ((startPos === 4 || startPos === 7) && !isAdding) {
        input.setSelectionRange(startPos - 1, startPos - 1);
      } else {
        input.setSelectionRange(startPos, startPos);
      }
    }
  }, 10);

  return typeof value === 'string' ? value : '';
};

export const yearCalculatorPR = () => {
  const referenceDate = new Date();
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Puerto_Rico',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }).formatToParts(referenceDate);

  const getPart = (type) => parts.find((p) => p.type === type)?.value;

  const year = parseInt(getPart('year'), 10);
  const month = parseInt(getPart('month'), 10);
  const day = parseInt(getPart('day'), 10);
  const hour = parseInt(getPart('hour'), 10);
  const minute = parseInt(getPart('minute'), 10);
  const second = parseInt(getPart('second'), 10);
  const currentDateInPR = new Date(year, month - 1, day, hour, minute, second);
  const april15Deadline = new Date(year, 3, 15, 23, 59, 59);
  const october15Deadline = new Date(year, 9, 15, 23, 59, 59);
  const isBtwAprilAndOct15 =
    currentDateInPR >= april15Deadline && currentDateInPR <= october15Deadline;

  return {
    year,
    month,
    day,
    hour,
    minute,
    second,
    currentDateInPR,
    october15Deadline,
    april15Deadline,
    isBtwAprilAndOct15,
  };
};

export const isIRAEducativaProduct = (product) =>
  commonTernary(productMapping(product) === PRODUCT_IRAEDUCATION, true, false);

export const isIRAProduct = (prod) =>
  commonTernary(
    isCDproduct(prod) || isCDIraproduct(prod) || isIRAEducativaProduct(prod),
    true,
    false
  );

export const isSimilarIRAProducts = (product) =>
  commonTernary(isCDIraproduct(product) || isIRAEducativaProduct(product), true, false);

export const getRoot = () => {
  const host = document.querySelector('sales-express-wc');
  return host?.shadowRoot || document;
};

export const getRequestSource = (context) => {
  let requestSource = '';
  if (context?.testWCFlow || context?.wcFlow) {
    requestSource = context?.requestSource || 'OMB';
  }
  return requestSource;
};

export const getDevicePlatform = (context) => {
  let devicePlatform = '';
  if ((context?.testWCFlow || context?.wcFlow) && context?.isMobileApp) {
    devicePlatform = 'D1 - Mobile';
  } else if ((context?.testWCFlow || context?.wcFlow) && !context?.isMobileApp) {
    devicePlatform = 'D1 - Web';
  }
  return devicePlatform;
};

// Helper: find a Window object that exposes Cordova (current, parent, or top)
export const findCordovaRoot = () => {
  try {
    if (typeof window !== 'undefined' && window.cordova) return window;
  } catch (e) {
    console.log('Accessing window.cordova threw:', e);
  }
  try {
    if (window.parent && window.parent !== window && window.parent.cordova) return window.parent;
  } catch (e) {
    console.log('Accessing window.parent.cordova threw:', e);
  }
  try {
    if (window.top && window.top !== window && window.top.cordova) return window.top;
  } catch (e) {
    console.log('Accessing window.top.cordova threw:', e);
  }
  return null;
};

/**
 * cordovaFileUtils.js
 *
 * Utility to handle Cordova iOS and Android file object incompatibilities.
 *
 * Uses the existing findCordovaRoot() helper already present in the project
 * to detect platformId — same pattern used in saveFileInCordova().
 *
 * NO new platform detection logic — reuses existing codebase pattern:
 *   const root = findCordovaRoot();
 *   const platformId = root?.cordova?.platformId || window.cordova?.platformId;
 */

/**
 * Gets Cordova platformId using the existing findCordovaRoot helper.
 * Exactly matches the pattern used in saveFileInCordova():
 *
 *   const root = findCordovaRoot();
 *   const platformId = root?.cordova?.platformId || window.cordova?.platformId;
 *
 * @returns {string|undefined} 'android' | 'ios' | undefined
 */
export const getCordovaPlatformId = () => {
  const root = findCordovaRoot();
  return root?.cordova?.platformId || window?.cordova?.platformId || 'cordova';
};

export const resolveFileToBlob = (file) =>
  new Promise((resolve, reject) => {
    // ✅ WEB SHORT-CIRCUIT
    if (file instanceof Blob) {
      resolve(file);
      return;
    }

    const TIMEOUT = 60000;
    const errors = [];

    const hasCordova = typeof window !== 'undefined' && window.cordova && window.cordova.file;

    const isCloudPath = (input) => {
      if (typeof input !== 'string') return false;
      const path = input.toLowerCase();

      return [
        'content://',
        'com.google.android.apps.docs',
        'com.microsoft.skydrive',
        'com.dropbox.android',
        'com.box.android',
        'icloud',
        'clouddocs',
        'com.apple.clouddocs',
      ].some((p) => path.includes(p));
    };

    /* ---------- Layer 1: copyTo (cloud-safe) ---------- */
    const tryCopyToCache = () =>
      new Promise((res, rej) => {
        // eslint-disable-next-line no-promise-executor-return
        if (!hasCordova) return rej(new Error('cordova-unavailable'));

        const timer = setTimeout(() => rej(new Error('copy-timeout')), TIMEOUT);
        const done =
          (fn) =>
          (...a) => {
            clearTimeout(timer);
            fn(...a);
          };

        window.resolveLocalFileSystemURL(
          file,
          (sourceEntry) => {
            window.resolveLocalFileSystemURL(
              window.cordova.file.cacheDirectory,
              (cacheDir) => {
                const name = sourceEntry.name || 'file';
                const destName = `cloud_${Date.now()}_${name}`;

                sourceEntry.copyTo(
                  cacheDir,
                  destName,
                  (copiedEntry) => {
                    copiedEntry.file(
                      done((nativeFile) =>
                        nativeFile && nativeFile.size
                          ? res(nativeFile)
                          : rej(new Error('copy-empty'))
                      ),
                      done(rej)
                    );
                  },
                  done(rej)
                );
              },
              done(rej)
            );
          },
          done(rej)
        );
      });

    /* ---------- Layer 2: filesystem ---------- */
    const tryFileSystem = () =>
      new Promise((res, rej) => {
        // eslint-disable-next-line no-promise-executor-return
        if (!hasCordova) return rej(new Error('cordova-unavailable'));

        window.resolveLocalFileSystemURL(
          file,
          (entry) => {
            entry.file(
              (nativeFile) =>
                nativeFile && nativeFile.size ? res(nativeFile) : rej(new Error('fs-empty')),
              rej
            );
          },
          rej
        );
      });

    /* ---------- Layer 3: XHR ---------- */
    const tryXHR = () =>
      new Promise((res, rej) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', file, true);
        xhr.responseType = 'arraybuffer';
        xhr.timeout = TIMEOUT;

        xhr.onload = () =>
          xhr.response && xhr.response.byteLength
            ? res(new Blob([xhr.response]))
            : rej(new Error('xhr-empty'));

        xhr.onerror = () => rej(new Error('xhr-error'));
        xhr.ontimeout = () => rej(new Error('xhr-timeout'));
        xhr.send();
      });

    const layers = isCloudPath(file)
      ? [tryCopyToCache, tryFileSystem, tryXHR]
      : [tryFileSystem, tryXHR, tryCopyToCache];

    const runNext = async (index) => {
      if (index >= layers.length) {
        reject(new Error(`resolveFileToBlob failed:\n${errors.join('\n')}`));
        return;
      }

      const fn = layers[index];

      try {
        const blob = await fn();
        resolve(blob);
      } catch (e) {
        errors.push(`layer-${index}: ${e.message}`);
        runNext(index + 1);
      }
    };

    runNext(0);
  });

// to check whether its cordova in D1
export const isCordovaFn = () => !!window.cordova;

export const getRuntimePlatform = () => {
  if (window.cordova) {
    return window.device?.platform || 'cordova';
  }
  return 'web';
};
